import React, { useEffect, useState } from "react";
import axios from '../axios/axiosconf';
import { useHistory } from "react-router";
import { useLocation } from "react-router-dom";
import { getHashRouterSearchString } from '../../utils/hashRouterQuery';

function ResetPassword() {
    
    //const queryParams = new URLSearchParams(window.location.search);

    const [tokenIsvalid] = useState(true);
    const [password, setPassword] = useState();
    const [passwordConfirm, setPasswordConfirm] = useState();
    const [feedbackType, setFeedbackType] = useState('invalid-feedback');
    const [msg, setMsg] = useState('');
    const [loading, setLoading] = useState(false);
    const [errorList] = useState();
    let history = useHistory();

    const location = useLocation();
    const search = getHashRouterSearchString(location);
    const token = new URLSearchParams(search).get('token');
    const email = new URLSearchParams(search).get('email');
    
    /*useEffect(() => {
        console.log('token: '+token+', email: '+email);
    },[]);*/


    useEffect(() => {
            
    },[]);


    const handleSubmit = (e) => {
        e.preventDefault();
        setLoading(true);

        axios.post('/reset-password', {
            token: token,
            email: email,
            password: password,
            password_confirmation: passwordConfirm
        })
            .then(response => {

                console.log('Ok...');
                console.log(response.data);

                setLoading(false);
                setFeedbackType('valid-feedback visible');
                setMsg(response.data.message);
                //setErrorlist({});

                setTimeout(() => {
                    history.push('/');
                }, 4000);
                
                if (response.status===200) {
                    //setUsername(userdata.user_name);
                    
                    //setClient(response.data);
                    //setLoggedIn(true);
                    
                }
            })
            .catch(error => {
                
                setLoading(false);
                setFeedbackType('invalid-feedback visible');
                setMsg(error.response?.data?.message || 'Error al procesar la solicitud');
                //setErrorlist(error.response?.data?.errors || {});
                
                
                console.log('err: '+JSON.stringify(error.response?.data?.message));
            });
    }

    if (tokenIsvalid) {

        return (
            <div className="login-page">
                <div className="login-box">
                    <div className="card card-outline card-primary">
                        <div className="card-header text-center">
                        <img src="dist/img/logo_smile.jpg" alt="Logo Smile" style={{width: '150px'}} />
                        </div>
                        <div className="card-body">
                        <p className="login-box-msg">Restablecer contraseña</p>

                        <form onSubmit={handleSubmit} method="post">
                            <input type="hidden" value={token} />
                            <div className="input-group mb-3">
                                <input type="password" className="form-control" placeholder="Contraseña" onChange={(e) => setPassword(e.target.value)} />
                                <div className="input-group-append">
                                    <div className="input-group-text">
                                    <span className="fas fa-lock"></span>
                                    </div>
                                </div>
                            </div>
                            <div className="input-group mb-3">
                                <input type="password" className="form-control" placeholder="Confirmar contraseña" onChange={(e) => setPasswordConfirm(e.target.value)} />
                                <div className="input-group-append">
                                    <div className="input-group-text">
                                    <span className="fas fa-lock"></span>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12">
                                    <button type="submit" className="btn btn-primary btn-block">
                                        Cambiar contraseña&nbsp;
                                        {loading ? (<span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>) : null }
                                    </button>
                                </div>
                            </div>
                            <div className={feedbackType}>
                            {msg}
                            {errorList}
                            </div>
                        
                        </form>

                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="alert alert-warning">Acceso restringido</div>
    );
}
export default ResetPassword;